/**
 * @module App
 * @description Top level application component. The entire react application stems from this component.
 */

/* global window */

import React from 'react';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import history from './history';
import reducers from './reducers';
import sagas from './sagas';
import Routes from './routes';
import './App.css';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line

const historyMiddleware = routerMiddleware(history);

/* eslint-disable no-underscore-dangle */
const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  composeEnhancers(
    applyMiddleware(sagaMiddleware),
    applyMiddleware(historyMiddleware)
  )
);
/* eslint-enable */

sagaMiddleware.run(sagas);

const App = () => (
  <Provider store={store}>
    <Routes />
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js